module.exports = __webpack_public_path__ + "img/img4.6d73027a.png";